
































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ProgressBar extends Vue {
  /** 0-100 */
  @Prop({ required: true })
  readonly progress: number

  @Prop({ required: false, default: '#D1D1D1' })
  readonly color: string

  @Prop({ required: false, default: '#000000' })
  readonly fillColor: string

  get normalizedProgressPercent(): number {
    const min = 0
    const max = 100
    if (this.progress < min) {
      return min
    }
    if (this.progress > max) {
      return max
    }

    return this.progress
  }
}
